import Api from './Api';

const all = (payload) => {
    const path = '/payment-settings';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/payment-settings/update',
        method: 'PUT',
        data: payload
    });
};

const sorted = (payload) => {
    return Api.postRequest({
        endpoint: '/payment-settings/sorted',
        method: 'PUT',
        data: payload
    });
};

export default {
    all,
    update,
    sorted
};
